/** @format */

import { Component, input, output, ChangeDetectionStrategy, inject } from '@angular/core';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import {
  homefieldIconAlertErrorOutline,
  HomefieldIconLibraryModule,
  HomefieldIconsLibraryService,
} from '@dsg-tech/homefield-angular-icons';

@Component({
  selector: 'compare-api-failure',
  templateUrl: './api-failure.component.html',
  styleUrls: ['./api-failure.component.scss'],
  imports: [HmfButtonComponent, HomefieldIconLibraryModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApiFailureComponent {
  private readonly hmfIconService = inject(HomefieldIconsLibraryService);

  readonly canRetryApiCall = input<boolean>();
  readonly tryAgain = output<void>();
  readonly continueBrowsing = output<void>();

  constructor() {
    this.hmfIconService.registerIcons([homefieldIconAlertErrorOutline]);
  }

  onTryAgainClick(): void {
    this.tryAgain.emit();
  }

  onContinueBrowsing(): void {
    this.continueBrowsing.emit();
  }
}
